module.exports = __webpack_public_path__ + "static/media/main26.54003389.png";